// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-L":"L_shp2-detail-L__a5dK7"};